async function findWallpaper(id: string) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/wallpapers/${id}`;

  const res = await fetch(url, { credentials: "include" });
  const wallpaper = await res.json();

  return wallpaper;
}

export default findWallpaper;
